import { render, staticRenderFns } from "./Resent.vue?vue&type=template&id=c5927104&"
import script from "./Resent.vue?vue&type=script&lang=js&"
export * from "./Resent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports